import { useState } from 'react';
import { GroupsService } from '../ApiGroups';
import { buildDrawAll, buildGroup, buildGroupDetail } from './games';

export function useGroups() {
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<any>(null);

    const fetchGroups = async (params?: any) => {
        setLoading(true);
        const response: any = await GroupsService.getGroups(params ? params : {});
        if (response.code === 0) {
            setGroups(response.data.map((group: any) => (
                buildGroup(group)
            )));
        } else {
            setError(response.message);
        }
        setLoading(false);
    };

    return { groups, fetchGroups, loading, error };
}

export function useGroupInfo() {
    const [groupInfo, setGroupInfo] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<any>(null);

    const fetchGroupInfo = async (id: any) => {
        setLoading(true);
        const response: any = await GroupsService.getGroupInfo(id);
        if (response.code === 0) {
            console.log("response.data", response)
            const drawData = buildDrawAll(response.data.draw);
            setGroupInfo(buildGroupDetail(response.data, drawData));
        } else {
            setError(response.message);
        }
        setLoading(false);
    };

    return { groupInfo, fetchGroupInfo, loading, error };
}
